import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { Util } from '@/repository/repositories/utils';
import {
  FindOneTaskResponse,
  FindTaskCommentsQuery,
  FindTaskCommentsResponse,
  FindTasksResponse,
  FindTasksQuery,
  UpdateTaskParam,
  UpdateTaskCustomAttributesParam,
  CreateTaskParam,
  FindOneTaskQuery,
  UpdateModeTaskQuery,
  CreateTaskCommentQuery,
  CreateTaskResponse,
  CreateTaskCommentResponse,
  UpdateTaskResponse,
  UpdateTaskCustomAttributeResponse,
} from '@/@types/Task';
import { vxm } from '@/store';

export class TasksRepository {
  private readonly requestBaseUrl = 'v1/tasks';
  private readonly axios = new TheoryApiAxiosBase();
  private readonly util = new Util();
  /** 課題登録 */
  async createTask (param: CreateTaskParam) {
    return (await this.axios.post<CreateTaskResponse>(this.requestBaseUrl, param)).data;
  }

  /**  課題詳細取得 */
  async findOneTask (taskId: number, query: FindOneTaskQuery) {
    const endPoint = this.endPointCreator(taskId);
    return (await this.axios.get<FindOneTaskResponse>(
      endPoint,
      { params: query },
    )).data;
  }

  /** 課題一覧取得 */
  async findTasks (query: FindTasksQuery) {
    return (await this.axios.get<FindTasksResponse>(
      this.requestBaseUrl,
      { params: query },
    )).data;
  }

  /** 課題更新 */
  async updateTask (
    taskId: number,
    param: UpdateTaskParam,
    query: UpdateModeTaskQuery
  ) {
    const endPoint = this.endPointCreator(taskId);
    return (await this.axios.patch<UpdateTaskResponse>(endPoint, param, { params: query })).data;
  }

  /** 課題カスタム属性更新 */
  async updateTaskCustomAttributes (
    taskId: number,
    param: UpdateTaskCustomAttributesParam,
    query: UpdateModeTaskQuery,
  ) {
    const endPoint = this.endPointCreator(
      taskId,
      'custom-attributes',
    );
    return (await this.axios.patch<UpdateTaskCustomAttributeResponse>(endPoint, param, { params: query })).data;
  }

  /** 課題コメント登録 */
  async createTaskComment (
    taskId: number,
    param: FormData,
    query: CreateTaskCommentQuery,
  ) {
    const endPoint = this.endPointCreator(taskId, 'comments');
    return (await this.axios.post<CreateTaskCommentResponse>(endPoint, param, {
      params: query,
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-role-param': `{"organizationId":${vxm.theoryApi.authStore.getCurrentOrganizationId},"projectId":${1}}`,
      },
    })).data;
  }

  /** 課題コメント一覧取得 */
  async findTaskComments (
    taskId: number,
    query: FindTaskCommentsQuery
  ) {
    const endPoint = this.endPointCreator(taskId, 'comments');
    return (await this.axios.get<FindTaskCommentsResponse>(
      endPoint,
      { params: query },
    )).data;
  }

  private endPointCreator(...paths: (string | number)[]) {
    return this.util.endPointCreator(this.requestBaseUrl, ...paths);
  };
}
